@if (visible()) {
  <div class="content-language-switcher" role="group" [attr.aria-label]="'Episodes shared.Language' | translate"
    [class.content-language-switcher--busy]="disabled()">
    <mat-icon class="content-language-switcher__icon" aria-hidden="true">translate</mat-icon>
    @for (option of options(); track option.locale) {
      <button type="button"
        class="content-language-switcher__option"
        [class.content-language-switcher__option--active]="option.isSelected"
        [attr.aria-pressed]="option.isSelected"
        [attr.title]="option.label"
        [attr.aria-label]="option.label"
        [disabled]="disabled()"
        (click)="select(option, $event)">
        {{ option.short }}
      </button>
    }
  </div>
}
